module.exports = __webpack_public_path__ + "assets/overlay-front-teeth-apart.573db0e9dbf5ae9c577b100d93798b95.png";